<template>
  <div>
    <h4 class="" style="font-weight: 500; margin-bottom: 0;">My Candidates</h4>
    <hr>
    <p v-if="relationships.length === 0">No nannies have been linked yet, we're currently searching and you'll be notified shortly!</p>
    <div v-else class="mb-2">
      <p>Click the "View Profile" button to learn more about a nanny! (Their profile will open in a new tab)</p>
      <p>Once you've decided whether or not you'd like to meet them, please click "I'm Interested" or "I'm Not Interested" to let us know!</p>
    </div>
    <div class="row mt-3">
      <!-- <div v-for="(candidate, index) in relationshipCandidates" :key="candidate.id" class="col-lg-4">
        <div class="p-4" style="border: 1px solid var(--bootstrapgrey); border-radius: 2px;">
          <div class="center">
            <img :src="candidate.profile_pic" alt="" style="border-radius: 2px; height: 175px;">
            <h4 class="mt-3" style="margin-bottom: 0;">{{ candidate.first_name }} {{ candidate.last_name }}</h4>
            <p>Status: {{ relationships[index].status }}</p>
            <p>{{ relationships[index] }}</p>
            <div style="margin-top: 20px; margin-bottom: 20px;">
              <router-link
                :to="{ name: 'Candidate Viewable Dashboard', params: { id: candidate.id } }"
                class="mylisting-button dark-button mt-2"
                target="_blank"
              >View Profile</router-link>
            </div>
            <p class="" v-if="relationships[index].status == 'Under Consideration'"><span style="cursor: pointer;" @click="updateRelationshipStatus('Interested', relationships[index])">I'm Interested</span> | <span style="cursor: pointer;" @click="updateRelationshipStatus('Not Interested', relationships[index])">I'm Not Interested</span></p>
          </div>
        </div>
      </div> -->
      <div v-for="relationship in relationships" :key="relationship.id" class="col-lg-6 mb-4">
        <div class="p-4 px-5" style="border: 1px solid var(--bootstrapgrey); border-radius: 2px;">
          <div class="center">
            <h4 class="mt-3" style="margin-bottom: 5px;">{{ relationship.candidate_name }}</h4>
            <p>Status: {{ relationship.status }}</p>
            <hr>
            <p v-if="relationship.text7">Notes: {{ relationship.text7 }}</p>
            <div style="margin-top: 25px; margin-bottom: 25px;">
              <router-link
                :to="{ name: 'Candidate Viewable Dashboard', params: { id: relationship.candidate } }"
                class="mylisting-button dark-button mt-2"
                target="_blank"
              >View Profile</router-link>
            </div>
            <p class="" v-if="relationship.status == 'Under Consideration'"><span style="cursor: pointer;" @click="updateRelationshipStatus('Interested', relationship)">I'm Interested</span> | <span style="cursor: pointer;" @click="updateRelationshipStatus('Not Interested', relationship)">I'm Not Interested</span></p>
            <button v-if="relationship.status == 'Interested'" class="mylisting-button dark-button" @click="showOfferModal(relationship)">Extend Offer</button>
          </div>
        </div>
      </div>
    </div>

    <modal name="schedule-interview-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thanks for letting us know you are interested!</h2>
        <p>The next step is for us to schedule an interview/trial day with you and the nanny. Please fill in this form:</p>
        <hr>
        <div class="field-of-fields">
          <label style="margin-top: 0;">Would you prefer to start with a video meeting (Zoom or Facetime) or in person?</label>
          <input type="text" class="form-control" v-model="videoOrInPerson">
          <label>Please let us know some upcoming days and times when you are available</label>
          <textarea rows="4" class="form-control" v-model="availability"></textarea>
        </div>
        <hr>
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('job-updated-modal')" style="">Close</button> -->
        <button class="mylisting-button dark-button mb-5" style="float: right;" @click="submitScheduleForm()">Submit</button>
      </div>
    </modal>

    <modal name="not-interested-feedback-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thanks for letting us know you are not interested in this nanny.</h2>
        <p>Can you please give us some feedback as to why so we can find someone more suitable?</p>
        <hr>
        <div class="field-of-fields">
          <!-- <label style="margin-top: 0;">Would you prefer to start with a video meeting or in person?</label> -->
          <!-- <input type="text" class="form-control" v-model="videoOrInPerson"> -->
          <!-- <label style="margin-top: 0;">Please let us know some upcoming days and times when you are available</label> -->
          <textarea rows="4" class="form-control" v-model="feedback"></textarea>
        </div>
        <hr>
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('job-updated-modal')" style="">Close</button> -->
        <button class="mylisting-button dark-button mb-5" style="float: right;" @click="submitFeedbackForm()">Submit</button>
      </div>
    </modal>

    <modal name="extend-offer-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Extend an Offer</h2>
        <p>Thanks for your interest in hiring this nanny. To extend an offer, please fill in the following details:</p>
        <hr>
        <div class="field-of-fields">
          <label class="top-label">Pay rate</label>
          <small>Most professional nannies are paid $20-30 per hour, depending on experience.</small>
          <input type="text" class="form-control" v-model="payRate">
          <label>Contract Duration</label>
          <small>For example, 1 year</small>
          <input type="text" class="form-control" v-model="contractDuration">
          <label>Schedule/Hours</label>
          <small>For example, guaranteeing 40 hours whether worked or not. M-F 8:30AM-5PM</small>
          <textarea rows="3" class="form-control" v-model="daysHours"></textarea>
          <label>Paid Holidays</label>
          <small>For example, New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day and Christmas Day.</small>
          <textarea rows="3" class="form-control" v-model="paidTimeOff"></textarea>
          <label>Paid Vacation</label>
          <small>For example, 10 days</small>
          <input type="text" class="form-control" v-model="paidVacation">
          <label>Paid Sick Days</label>
          <small>For example, 5 days</small>
          <input type="text" class="form-control" v-model="paidSickDays">
          <label>Payment Frequency</label>
          <small>For example, weekly or bi-Weekly</small>
          <input type="text" class="form-control" v-model="paymentFrequency">
          <label>Health Insurance Stipend</label>
          <!-- <small>For example, 10 days</small> -->
          <input type="text" class="form-control" v-model="healthInsurance">
          <label>Mileage Reimbursement</label>
          <small>For on the job travel at the IRS rate of 57.5 cents per mile.</small>
          <input type="text" class="form-control" v-model="mileageReimbursement">
          <!-- <label>Anticipated start date</label>
          <input type="text" class="form-control" v-model="startDate"> -->
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('extend-offer-modal')" style="">Close</button>
        <button class="mylisting-button dark-button mb-5" style="float: right;" @click="extendOffer()">Submit</button>
      </div>
    </modal>

    <modal name="submitted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thanks, we will be in touch shortly!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('submitted-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      relationships: [],
      relationship: {},
      relationshipCandidates: [],

      videoOrInPerson: '',
      availability: '',

      feedback: '',

      payRate: '',
      contractDuration: '',
      daysHours: '',
      paidTimeOff: '',
      paidVacation: '',
      paidSickDays: '',
      paymentFrequency: '',
      healthInsurance: '',
      mileageReimbursement: '',
      // startDate: '',
    }
  },
  created() {
    // this.candidateEmployerRelationshipStatuses = this.$store.getters.candidateEmployerRelationshipStatuses
    this.getRelationships()
  },
  methods: {
    getRelationships() {
      axios.get(`/api/relationships/?employer=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.relationships = res.data
          this.relationships = this.relationships.sort((a, b) => (a.id < b.id) ? 1 : -1)

          // this.relationshipCandidates = []
          // for (var relationship in this.relationships) {
          //   axios.get(`/api/people/?id=${this.relationships[relationship].candidate}`)
          //     .then(res => {
          //       console.log(res)
          //       // this.relationshipCandidates.push(res.data[0])
          //       // https://stackoverflow.com/questions/35817565/how-to-filter-array-when-object-key-value-is-in-array
          //       // let correspondingRelationship = this.relationships.filter( x => x.candidate == res.data[0].id )[0]
          //       // console.log(correspondingRelationship)
          //       // this
          //     })
          //     .catch(error => console.log(error));
          // }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateRelationshipStatus(status, relationship) {
      console.log(status)
      console.log(relationship)

      if (status == 'Interested') {
        this.relationship = relationship
        this.$modal.show('schedule-interview-modal')

        this.$store.dispatch('sendEmails',
          {
            subject: `Client ${this.relationship.employer_name} Interested in ${this.relationship.candidate_name}`,
            message: 'Hello,' + '\n\n' +
            `The client ${this.relationship.employer_name} is interested in the nanny ${this.relationship.candidate_name}!\n` +
            `\n` +
            `Cheers!`,
            from: this.$store.getters.agencyFromEmail,
            emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
            reply: this.$store.getters.agencyReplyEmail,
            userID: 4,
          }
        )
      }
      else {
        this.relationship = relationship
        this.$modal.show('not-interested-feedback-modal')

        this.$store.dispatch('sendEmails',
          {
            subject: `Client ${this.relationship.employer_name} NOT Interested in ${this.relationship.candidate_name}`,
            message: 'Hello,' + '\n\n' +
            `The client ${this.relationship.employer_name} is NOT interested in the nanny ${this.relationship.candidate_name}!\n`,
            from: this.$store.getters.agencyFromEmail,
            emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
            reply: this.$store.getters.agencyReplyEmail,
            userID: 4,
          }
        )
      }

      axios.patch(`/api/relationships/${relationship.id}/`, {
        status: status
      })
        .then(res => {
          console.log(res)
          this.getRelationships()
        })
        .catch(error => console.log(error));
    },
    submitScheduleForm() {
      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        text1: this.videoOrInPerson,
        text2: this.availability,
      })
        .then(res => {
          this.$modal.hide('schedule-interview-modal')
          this.$modal.show('submitted-modal')

          this.$store.dispatch('sendEmails',
            {
              subject: `Client ${this.relationship.employer_name} Interested in ${this.relationship.candidate_name}`,
              message: 'Hello,' + '\n\n' +
              `The client ${this.relationship.employer_name} is interested in the nanny ${this.relationship.candidate_name}!\n` +
              `Client meeting preference: ${this.videoOrInPerson}\n` +
              `Client availability: ${this.availability}\n\n` +
              `Cheers!`,
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
              reply: this.$store.getters.agencyReplyEmail,
              userID: 4,
            }
          )


        })
        .catch(error => console.log(error))
    },
    submitFeedbackForm() {
      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        text7: this.feedback,
      })
        .then(res => {
          this.$modal.hide('not-interested-feedback-modal')
          this.$modal.show('submitted-modal')

          this.$store.dispatch('sendEmails',
            {
              subject: `Client Feedback - ${this.relationship.employer_name} NOT Interested in ${this.relationship.candidate_name}`,
              message: 'Hello,' + '\n\n' +
              `The client ${this.relationship.employer_name} is NOT interested in the nanny ${this.relationship.candidate_name}\n` +
              `Client feedback: ${this.feedback}\n`,
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
              reply: this.$store.getters.agencyReplyEmail,
              userID: 4,
            }
          )
        })
        .catch(error => console.log(error))
    },
    showOfferModal(relationship) {
      this.relationship = relationship
      this.$modal.show('extend-offer-modal')
    },
    extendOffer() {
      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        text3: this.daysHours,
        text4: this.payRate,
        text5: this.paidTimeOff,
        // text6: this.startDate,
        text6: this.contractDuration,
        // text7 got taken by admin notes for client
        text8: this.paidVacation,
        text9: this.paidSickDays,
        text10: this.paymentFrequency,
        text11: this.healthInsurance,
        text12: this.mileageReimbursement,
        status: 'Offer Extended',
      })
        .then(res => {
          this.$modal.hide('extend-offer-modal')
          this.$modal.show('submitted-modal')
          this.getRelationships()

          this.$store.dispatch('sendEmails',
            {
              subject: `Client ${this.relationship.employer_name} extended offer to ${this.relationship.candidate_name}`,
              message: 'Hello,' + '\n\n' +
              `The client ${this.relationship.employer_name} has extended an offer to the nanny ${this.relationship.candidate_name}!\n` +
              `Pay rate: ${this.payRate}\n` +
              `Contract Duration: ${this.contractDuration}\n` +
              `Schedule/hours: ${this.daysHours}\n` +
              `Paid Holidays: ${this.paidTimeOff}\n` +
              `Paid Vacation: ${this.paidVacation}\n` +
              `Paid Sick Days: ${this.paidSickDays}\n` +
              `Payment Frequency: ${this.paymentFrequency}\n` +
              `Health Insurance Stipend: ${this.healthInsurance}\n` +
              `Mileage Reimbursement: ${this.mileageReimbursement}\n\n` +
              `Cheers!`,
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
              reply: this.$store.getters.agencyReplyEmail,
              userID: 4,
            }
          )

          // axios.get(`/api/people/?id=${this.relationship.candidate}`)
          //   .then(res => {
          //     let candidate = res.data[0]

          //     this.$store.dispatch('sendEmails',
          //       {
          //         subject: `Client ${this.relationship.employer_name} extended offer to ${this.relationship.candidate_name}`,
          //         message: `Hi ${candidate.first_name},` + '\n\n' +
          //         `Thank you for being such a wonderful nanny candidate! We are so excited to inform you that you have been offered the nanny position for ${this.relationship.employer_name}. They really enjoyed meeting you and feel that with your personality and skills that you would be a wonderful fit in their home and an asset to their family. \n` +
          //         `Pay rate: ${this.payRate}\n` +
          //         `Contract Duration: ${this.contractDuration}\n` +
          //         `Schedule/hours: ${this.daysHours}\n` +
          //         `Paid Holidays: ${this.paidTimeOff}\n` +
          //         `Paid Vacation: ${this.paidVacation}\n` +
          //         `Paid Sick Days: ${this.paidSickDays}\n` +
          //         `Payment Frequency: ${this.paymentFrequency}\n` +
          //         `Health Insurance Stipend: ${this.healthInsurance}\n` +
          //         `Mileage Reimbursement: ${this.mileageReimbursement}\n\n` +
          //         `Cheers!`,
          //         from: this.$store.getters.agencyFromEmail,
          //         emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
          //         reply: this.$store.getters.agencyReplyEmail,
          //         userID: 4,
          //       }
          //     )
          //   })
          //   .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/MyCandidates.vue